
import {defineComponent} from 'vue'
import { ReportChart, ReportChartOption } from '@/model/models'
import { Chart, registerables } from 'chart.js'
import { LineChart } from 'vue-chart-3'

Chart.register(...registerables)

export default defineComponent( {
  name: 'ReportLineChart',
  components: {
    LineChart
  },
  props: {
    chart: ReportChart,
    chartData: {}
  },
  computed: {
    chartOptions() {
      return {
        // For chart options see https://www.chartjs.org/docs
        responsive: true,
        pointRadius: this.chart!.options.indexOf(ReportChartOption.Dots) >= 0 ? 4 : 0,
        plugins: {
          // legend: {
          //   display: this.chart!.options.indexOf(ReportChartOption.Legend) >= 0,
          //   position: 'top'
          // },
          tooltip: {
            padding: 10,
            boxPadding: 10
          },
          datalabels: {
            // For label options see https://chartjs-plugin-datalabels.netlify.app
            display: false
          }
        }
      }
    }
  }
})
